<template>
    <div>
        <Alerts :_success="success" :_error="error" :_loading="wait"></Alerts>

        <ul class="nav nav-tabs">
            <li class="nav-item" v-for="(tab, index) in tabs" :key="index">
                <a class="nav-link" :class="{ active: activeTab === index }" href="#"
                   @click.prevent="setActiveTab(index)">
                    {{ tab.name }}
                </a>
            </li>
        </ul>

        <div class="border border-top-0 bg-white p-4">
            <div v-if="activeTab === 0">
                <h5 class="font-weight-bold">Leave Types & Tabulation</h5>
                <div class="clearfix"></div>
                <p>
                    This leave policy is applicable to all full time permanent staff of OI as well as consultants who
                    are on a
                    minimum of one year contract. <br>
                    For more details, read through the <a :href="policy_url" target="_blank">OI Rest and Leave Policy
                    Guideline</a>

                    <br>
                    <a :href="policy_url" target="_blank"
                       class="btn btn-outline-dark btn-sm mt-2">Download OI Rest and Leave Policy Guideline &raquo;</a>
                </p>

                <h5 class="font-weight-bold">Tabulation</h5>
                <div id="leaveAccordion" class="bg-light p-3 accordion rounded-lg border">
                    <div v-for="(leave, index) in leave_types" :key="index" class="mb-3">
                        <div class="font-weight-bold p-1" :id="'heading' + index">

                            <a href="javascript:void(0)" :class="{ collapsed: index !== activeIndex }" type="button"
                               @click="toggleAccordion(index)">
                                <span v-if="index ==  activeIndex">&laquo;</span>
                                <span v-else>&raquo;</span>

                                {{ leave.name }}
                                <sup v-if="leave.id ==1" class="badge badge-danger">NEW</sup>
                            </a>
                        </div>
                        <div :id="'collapse' + index" class="collapse"
                             :class="{ show: index === activeIndex }"
                             :aria-labelledby="'heading' + index">
                            <div class="border p-2 rounded-lg bg-white" v-html="leave.description"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="activeTab === 1">
                <div v-if="leaves.length == 0" class="p-4 text-muted">
                    You have not applied for any leave days

                    <div class="mt-4">
                        <button class="btn btn-outline-success" @click="activeTab=2">Apply Now</button>
                    </div>
                </div>
                <div v-else>
                    <div v-if="record">
                        <button v-if="record" @click="(record = '')" class="btn btn-sm btn-secondary float-right">
                            Go Back
                        </button>
                        <h5 class="font-weight-bold mb-0">
                            {{ record.leave_type.name }} -
                            {{ day(record.start_date).format('MMM, DD YYYY') }}
                            ({{ record.days }} {{ record.days === 1 ? 'day' : 'days' }})
                        </h5>
                        <p class="text-muted">View leave details and approval status</p>
                        <LeaveCalendar class="mb-3" :leave="record"></LeaveCalendar>

                        <div class="row">
                            <div class="col-md-7">
                                <div class="border mb-3">
                                    <table class="table table-borderless">
                                        <tr>
                                            <th style="width: 30%">Date Applied</th>
                                            <td>{{ day(record.created_at).format('MMM, DD YYYY H:mm') }}</td>
                                        </tr>
                                        <tr>
                                            <th>Status</th>
                                            <td><span :class="`status ${record.status}`">{{ record.status }}</span></td>
                                        </tr>
                                        <tr>
                                            <th>Leave Type</th>
                                            <td>{{ record.leave_type.name }}</td>
                                        </tr>
                                        <tr>
                                            <th>Leave Days</th>
                                            <td>{{ record.days }} Days</td>
                                        </tr>
                                        <tr>
                                            <th>Leave Start Date</th>
                                            <td>{{ day(record.start_date).format('MMM, DD YYYY') }}</td>
                                        </tr>
                                        <tr>
                                            <th>End Date</th>
                                            <td>{{ day(record.end_date).format('MMM, DD YYYY') }}</td>
                                        </tr>
                                        <tr>
                                            <th>Other Comments</th>
                                            <td>{{ record.memo ? record.memo : 'No comment' }}</td>
                                        </tr>
                                    </table>
                                </div>
                                <button @click="(record = '')" class="btn btn-outline-dark mr-1">
                                    Go Back
                                </button>
                                <template v-if="canEdit()">
                                    <button @click.prevent="editLeave(record)" class="btn btn-dark mr-1">
                                        Edit
                                    </button>
                                    <button @click.prevent="deleteLeave(record)" class="btn btn-danger">
                                        Delete
                                    </button>
                                </template>
                            </div>

                            <div class="col-md-5">
                                <div v-if="record">
                                    <div class="p-4 bg-white shadow-sm rounded mb-2">
                                        <h5 class="font-weight-bold">
                                            <span data-feather="check-circle" class="text-success"></span>
                                            Leave Approval Status
                                        </h5>

                                        <div v-if="record.isAuthorized">
                                            <p v-if="record.status==='approved'" class="text-muted">
                                                Leave Request is waiting for verification
                                            </p>
                                            <p v-else class="text-muted">Your request is {{ record.status }}</p>
                                            <b>Authorized on:</b>
                                            {{ day(record.approval.authorized_at).format('MMM, DD YYYY H:mm') }}<br>
                                        </div>
                                        <div v-else>
                                            <p>Request is {{ record.status }}</p>
                                            <p class="text-muted">
                                                Once your leave request is processed, you will get a notification on
                                                flock and on this
                                                app under
                                                <router-link to="/notifications">notifications page</router-link>
                                            </p>
                                        </div>
                                    </div>

                                    <div v-if="record.isApproved" class="p-4 bg-white shadow-sm mb-2">
                                        <h5 class="text-success font-weight-bold">
                                            <span data-feather="check-circle" class="text-success"></span>
                                            Leave Approval
                                        </h5>
                                        <p class="text-muted">Your Leave was approved</p>
                                        <div>
                                            <b>Date Approved:</b><span class="text-success"> </span>
                                            {{ day(record.approval.approved_at).format('MMM, DD YYYY H:mm') }} <br>
                                            <b>Approved By:</b> {{ record.approval.approved_by.name }} <br>
                                            <b>Approval Remarks:</b> {{ record.approval.approval_remarks }}
                                        </div>

                                        <p class="font-weight-bold mt-2 text-info" v-if="record.status=='approved'">
                                            Leave is waiting for verification
                                        </p>
                                    </div>

                                    <div v-if="record.isDeclined" class="p-4 bg-white shadow-sm mb-3">
                                        <h5 class="text-danger font-weight-bold">
                                            <span data-feather="x-circle" class="text-danger"></span>
                                            Leave Declined
                                        </h5>

                                        <p class="text-muted">Your request was declined</p>
                                        <div>
                                            <b>Date Declined:</b><span
                                            class="text-danger"> {{
                                                day(record.approval.declined_at).format('MMM, DD YYYY H:mm')
                                            }}  </span> <br>
                                            <b>Declined By:</b> {{ record.approval.declined_by.name }} <br>
                                            <b>Reason:</b> <span class="text-danger">{{
                                                record.approval.decline_remarks
                                            }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div v-for="i in leaves" :key="i.id" class="col-md-12">
                            <div class="border-bottom mb-3" @click="record=i" style="cursor:pointer">
                            <div class="card-body">
                                <h6 class="fw-bold mb-1">{{ i.leave_type.name }}</h6>
                                <p class="mb-1 text-muted small">
                                {{ day(i.start_date).format('MMM, DD YYYY') }} → {{ day(i.end_date).format('MMM, DD YYYY') }}
                                </p>
                                <span class="badge"
                                    :class="{'bg-success': i.status==='approved', 'bg-warning': i.status==='pending', 'bg-danger': i.status==='declined'}">
                                {{ i.status }}
                                </span>
                                <div class="mt-2 text-end">
                                <button class="btn btn-sm btn-outline-dark">View More →</button>
                                </div>
                            </div>
                            </div>
                        </div>
                     </div>

                </div>
            </div>

            <div v-if="activeTab === 2">
                <form @submit.prevent="sendApplication()">
                    <!-- Application Title -->
                    <div class="form-group row mb-1">
                        <div class="col-md-6 offset-md-3">
                            <h5 class="font-weight-bold">Leave Application Form</h5>
                        </div>
                    </div>

                    <!-- Leave Type -->
                    <div class="form-group row">
                        <label for="type" class="col-md-3 col-form-label text-md-right">Type of Leave</label>
                        <div class="col-md-6">
                            <multiselect
                                :options="leave_types"
                                v-model="selected_leave"
                                track-by="id"
                                label="name"
                                :searchable="true"
                                :allow-empty="false"
                                :hide-selected="true"
                                :disabled="wait"
                                @input="setSelectedLeaveType"
                            ></multiselect>
                            <div v-if="selected_leave" class="text-muted border p-2 my-2 rounded bg-light">
                                {{ selected_leave.description }}
                                <sup v-if="selected_leave.id ==1" class="badge badge-danger">NEW</sup>
                            </div>
                        </div>
                    </div>

                    <!-- Paternity/Maternity Leave Document Upload -->
                    <div class="form-group row" v-if="leave.type === 'Paternity' || leave.type === 'Maternity'">
                        <div class="offset-md-3 col-md-6">
                            <input type="file" class="form-control mb-2"/>
                            <p class="text-muted">Attach notification of birth, medical, or adoption records.</p>
                        </div>
                    </div>

                    <!-- Start Date -->
                    <div class="form-group row">
                        <label for="start-date" class="col-md-3 col-form-label text-md-right">Start Date</label>
                        <div class="col-md-6">
                            <Datepicker
                                id="start-date"
                                :bootstrap-styling="true"
                                v-model="leave.start_date"
                                maximum-view="day"
                                :disabled="wait"
                                placeholder="Select the start date"
                                :required="true"
                                :disabled-dates="disabledDates"
                                @selected="getLeaveEndDate"
                            ></Datepicker>
                        </div>
                    </div>

                    <!-- Leave Days -->
                    <div class="form-group row">
                        <label for="days" class="col-md-3 col-form-label text-md-right">Number of Leave Days</label>
                        <div class="col-md-6">
                            <input
                                type="number"
                                min="1"
                                class="form-control"
                                v-model="leave.days"
                                id="days"
                                @change="getLeaveEndDate"
                                placeholder="Enter the number of days requested"
                                :disabled="wait || !leave.start_date"/>
                            <div class="border p-2 rounded bg-light  font-weight-bold my-2" v-if="selected_leave.balance">
                                <div :class="selected_leave.balance == 0 ? 'text-danger':'text-success'">
                                    You have {{ selected_leave.balance }} leave days remaining.
                                </div>
                                <div v-if="leave.id">
                                    (Note: This doesn't include the {{ leave.days }} days from the request you're
                                    currently editing)
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- End Date -->
                    <div v-if="leave_end_date" class="form-group row">
                        <label for="end-date" class="col-md-3 col-form-label text-md-right">End Date</label>
                        <div class="col-md-6">
                            <!-- End Date Input with Popover -->
                            <input
                                id="end-date"
                                class="form-control text-success border-success font-weight-bold mb-1"
                                :value="leave_end_date"
                                disabled/>
                            <p class="text-success">Your leave will end on {{ leave_end_date }}</p>
                        </div>
                    </div>

                    <!-- Handover Staff -->
                    <div class="form-group row">
                        <label for="handover_staff" class="col-md-3 col-form-label text-md-right">Handover Staff</label>
                        <div class="col-md-6">
                            <multiselect
                                v-model="handover_staff"
                                id="handover_staff"
                                deselect-label="Staff already selected"
                                track-by="id"
                                label="name"
                                placeholder="Select staff for handover"
                                :options="staff"
                                :searchable="true"
                                :allow-empty="false"
                                :hide-selected="true"
                                @input="setHandoverStaffId"
                            ></multiselect>
                            <p class="text-muted" v-if="!leave.handover_staff">Select the person you are handing over
                                to.</p>
                        </div>
                    </div>

                    <!-- Additional Comments -->
                    <div class="form-group row">
                        <label for="memo" class="col-md-3 col-form-label text-md-right">Additional Comments</label>
                        <div class="col-md-6">
                            <textarea class="form-control"
                                      rows="3"
                                      v-model="leave.memo"
                                      id="memo"
                                      placeholder="Provide any additional comments or details"
                                      :disabled="wait"></textarea>
                        </div>
                    </div>

                    <!-- Submit Button -->
                    <div class="form-group row">
                        <div class="col-md-6 offset-md-3">
                            <button class="btn btn-dark" :disabled="wait">
                                <template v-if="wait">Please wait...</template>
                                <template v-else>Submit Application</template>
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <div v-if="activeTab === 3">
                <div class="float-right text-right">
                    <b>{{ auth.name }}</b><br>
                    <small>{{ auth.email }}</small>
                </div>
                <button class="btn btn-outline-success mb-3" :disabled="wait" @click="generateReport()">
                    <span v-if="wait" class="spinner-grow spinner-grow-sm"></span>
                    <span v-if="reportUrl">Re-</span>Generate Report
                    <span v-if="wait">.Please wait...</span>
                </button>

                <iframe v-if="reportUrl" :src="reportUrl" width="100%" style="height: 75vh"></iframe>
                <div v-else class="text-center small border rounded-lg p-3 text-muted">
                    Click on "generate" button to generate your leave days report
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Alerts from "@/components/Alerts";
import Datepicker from 'vuejs-datepicker'
import Multiselect from 'vue-multiselect'
import LeaveCalendar from "@/components/helpers/LeaveCalendar.vue";

export default {
    name: "Leave",
    props: ['auth'],
    components: {LeaveCalendar, Alerts, Datepicker, Multiselect},

    data() {
        return {
            tabs: [
                {name: "Types & Tabulation"},
                {name: "My Applications"},
                {name: "Apply Now"},
                {name: "Download Report"},
            ],
            activeTab: 0,

            leaves: [],
            selected_leave: {},
            leave_end_date: '',
            leave: {
                id: '',
                type: '',
                start_date: '',
                days: 0,
                handover_staff: '',
                memo: ''
            },
            policy_url: 'https://docs.google.com/document/d/1A4i3bhmsiyKo67CZszoK5HHWdKuoErZN/edit',
            record: '',
            staff: [],
            handover_staff: '',
            leave_types: [],
            disabledDates: {
                days: [6, 0],
                from: new Date(new Date().setDate(new Date().getDate() + 60)),
                to: new Date(new Date().setDate(new Date().getDate() - 3))
            },

            activeIndex: 0,
            leaveTypes: [],

            reportUrl: ''
        }
    },
    mounted() {
        this.loadLeaveTypes()
        this.loadLeaves()
        this.loadStaff()
    },
    computed: {
        today() {
            return new Date()
        }
    },
    methods: {
        setActiveTab(index) {
            this.activeTab = index;
        },
        toggleAccordion(index) {
            this.activeIndex = this.activeIndex === index ? -1 : index;
        },
        setHandoverStaffId() {
            this.leave.handover_staff = this.staff.find(a => a.id == this.handover_staff.id).id
        },
        setSelectedLeaveType() {
            this.leave.type = this.leave_types.find(a => a.id == this.selected_leave.id).id
        },
        generateReport() {
            this.setLoading()
            this.$http.post('leave/report', {user_id: this.auth.id}, {responseType: 'blob'}).then(response => {
                const pdfBlob = new Blob([response.data], {type: 'application/pdf'});
                this.reportUrl = URL.createObjectURL(pdfBlob);
            }).catch(error => {
                this.showError(error)
            }).then(() => {
                this.wait = false
            })
        },
        getLeaveEndDate() {
            if (this.leave.start_date && this.leave.days) {
                this.leave_end_date = 'Calculating...'
                this.$http.post('leave/end_date', this.leave).then(response => {
                    this.leave_end_date = response.data.data

                }).catch(error => {
                    this.showError(error)
                })
            }
        },
        setSelectedLeaveFromTable(record) {
            this.selected_leave = record
            this.leave.type = record.id
            this.show_tabulation = false
        },
        loadLeaveTypes() {
            this.setLoading()
            this.$http.get(('leave/types')).then(response => {
                this.leave_types = response.data.data
            }).catch(error => {
                this.showError(error)
            }).then(() => {
                this.wait = false
            })
        },
        loadLeaves() {
            this.$http.get(('user/leaves')).then(response => {
                this.leaves = response.data.data
            }).catch(error => {
                this.showError(error)
            })
        },
        loadStaff() {
            this.$http.get(('staff')).then(response => {
                this.staff = response.data.data
            }).catch(error => {
                this.showError(error)
            })
        },
        canEdit() {
            return (this.record.status === 'pending')
        },
        showRecord(record) {
            this.leave.type = record.id
            this.record = record
        },
        editLeave(record) {
            this.leave = record

            this.selected_leave = this.leave_types.find(a => a.id == record.type)
            this.handover_staff = this.staff.find(a => a.id == record.user_id)

            this.activeTab = 2
        },
        emptyForm() {
            this.leave = {
                id: '',
                type: 'Maternity',
                start_date: '',
                days: '',
                handover_staff: '',
                memo: ''
            }
        },
        deleteLeave(record) {
            if (confirm('Are you sure you want to delete this leave request?')) {
                this.$http.delete(`user/leaves/${record.id}?delete=true`).then(() => {
                    this.record = ''
                    this.loadLeaves();
                }).catch(error => {
                    this.showError(error)
                }).then(() => {
                    this.wait = false
                })
            }
        },

        sendApplication() {
            this.clear()
            this.setLoading()

            this.success = "Sending application, please wait..."
            this.leave.start_date = this.formatDate(this.leave.start_date)

            this.$http.post(`user/leaves/${this.leave.id}`, this.leave).then(res => {
                this.$toast.success('Leave created successfully!')
                this.success = "Your leave request was sent successfully. Please wait for approval"
                setTimeout(() => (this.success = ''), 2000)

                window.location = '/leave'

            }).catch(error => {
                this.showError(error)
            }).then(() => {
                this.wait = false
            })
        }
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

.nav-item a {
    font-weight: bold !important;
}

.tabulation tr td:first-child {
    font-weight: 400;
    color: #42B4FF;
    padding-right: 10px;
}

.custom-switch label {
    font-weight: normal;
}
</style>